import { Box, makeStyles } from '@material-ui/core';
import { Spinner } from 'react-bootstrap';
import SectionHeading from './SectionHeading';
import CardSlider from './CardSlider';
import themes from 'styles/themes';
import { ETypeStyle } from '.';
import { useDiscoverYourStyles } from 'hooks/useDiscoverYourStyles';
import { useHistory } from 'react-router-dom';
import { PATH } from 'routes/constant';
import { STRINGS } from 'constants/strings';

const useStyles = makeStyles((theme) => ({
    section: {
        background: themes.palette.common.white,
        marginTop: 12,
        marginBottom: 12,
        padding: '16px 0',
    },
}));

export const DiscoverYourStylesSession = () => {
    const classes = useStyles();
    const { loading, listStyles } = useDiscoverYourStyles();
    const history = useHistory();
    if (listStyles?.length || loading) {
        return (
            <Box className={classes.section}>
                <SectionHeading
                    title={STRINGS.HOME_DISCOVER_YOUR_STYLE_TITLE}
                    onClick={() => {
                        history.push(PATH.DISCOVER_YOUR_STYLE);
                    }}
                />
                {loading && (
                    <div className="d-flex justify-content-center">
                        <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />
                    </div>
                )}
                {listStyles.length ? (
                    <CardSlider
                        list={listStyles}
                        onItemClick={(style) => {
                            history.push(`${PATH.DISCOVER_YOUR_STYLE}`, {
                                taffiId: style?.taffiId,
                            });
                        }}
                        styleType={ETypeStyle.RECOMMEND_STYLE}
                    />
                ) : null}
            </Box>
        );
    }
    return null;
};
